// material-ui
import { useTheme } from '@mui/material/styles';

import logoDark from 'assets/images/logo.svg';
import logo from 'assets/images/logo.svg';

// ==============================|| LOGO ||============================== //

const Logo = () => {
    const theme = useTheme();

    // return <img src={theme.palette.mode === 'dark' ? logoDark : logo} style={{borderRadius: '15px'}} alt="Paydocs" width="200" />;
    return <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Paydocs" width="110" />;
};

export default Logo;
